import { useEffect } from "react"

import { Button, Divider, Flex, Spin, Switch, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { Outlet } from "react-router"

import Icon from "../../../Icon"
import Images from "../../../Images"
import { navActions } from "../../../Redux/nav/nav.slice"
import { isIncognitoAvailable, selectIncognito } from "../../../Utils/incognito"
import UserActions from "../../User/actions"

import "./styles.less"

const { Title, Text } = Typography

export const ReferralsOutsidersLayout = () => {
  const dispatch = useDispatch()
  const { isMobile } = useSelector((state) => state.nav)
  const { userInfo } = useSelector((state) => state.auth)
  const incognito = useSelector(selectIncognito)
  const incognitoAvailable = useSelector(isIncognitoAvailable)

  const isLoading = !userInfo

  const handleLogout = () => {
    dispatch(UserActions.logout())
  }

  const handleToggleIncognito = (checked) => {
    dispatch(navActions.navSetProp({ key: "incognito", value: checked }))
  }

  useEffect(() => {
    dispatch(UserActions.getUserInfo())
  }, [])

  useEffect(() => {
    document.title = "Referral - Chargeback"
  }, [])

  return (
    <Flex component="main" vertical className="referral-outsiders-layout" id="main-content">
      <Flex component="nav" className="nav-bar" justify="space-between" align="center">
        <div style={{ display: "flex" }}>
          <img src={Images.logo} alt="" width={32} />
          <Title
            level={3}
            style={{
              margin: "10px 10px 10px 6px",
              fontWeight: 600,
              whiteSpace: "nowrap"
            }}
          >
            Chargeback
          </Title>
        </div>
        <Flex align="center" gap={16}>
          {incognitoAvailable && (
            <>
              <Flex align="center" gap={8} className="incognito-toggle">
                <Switch
                  checked={incognito}
                  onChange={handleToggleIncognito}
                  style={incognito ? { backgroundColor: "#22C55E" } : undefined}
                />
                {!isMobile ? <Text>Incognito mode</Text> : null}
              </Flex>
              <Divider type="vertical" style={{ margin: 0, height: 24 }} />
            </>
          )}
          <Button
            type="text"
            icon={<Icon className="logout-icon" type="logout"></Icon>}
            onClick={handleLogout}
          >
            {!isMobile ? "Log out" : null}
          </Button>
        </Flex>
      </Flex>
      <div className="content">{isLoading ? <Spin fullscreen /> : <Outlet />}</div>
    </Flex>
  )
}

export default ReferralsOutsidersLayout
